/**
 * API 服务统一导出
 * 按照 Vue 最佳实践，将 API 服务统一管理
 */
import { authApi } from './auth'
import { productApi } from './product'
import { orderApi } from './order'
import { paymentApi } from './payment'
import { invitationApi } from './invitation'
import { trackingApi } from './tracking'
import { couponApi } from './coupon'
import { discountCodeApi } from './discountCode'

// 统一导出所有 API
export const api = {
  auth: authApi,
  product: productApi,
  order: orderApi,
  payment: paymentApi,
  invitation: invitationApi,
  tracking: trackingApi,
  coupon: couponApi,
  discountCode: discountCodeApi
}

// 也可以单独导出各个模块
export { authApi, productApi, orderApi, paymentApi, invitationApi, trackingApi, couponApi, discountCodeApi }

// 导出默认的 API 对象
export default api
